module.exports = __webpack_public_path__ + "static/media/Flaticon.fb5ae081.woff2";